import { useMemo } from 'react';

import { CloseIcon, Box, type ButtonProps } from '@frontend/legacy-components';

import { CASCADER_SUBCOMPONENT_NAMES } from '../consts';
import { useCascaderState, useCascaderComponentsContext } from '../context';
import type { CascaderOption, CascaderCommonProps } from '../types';

export interface ClearIndicatorProps<OptionType extends CascaderOption>
  extends ButtonProps {
  getCommonProps: () => CascaderCommonProps<OptionType>;
}

export const InternalClearIndicator = <OptionType extends CascaderOption>() => {
  const { cascaderStyles, getCommonProps, handleClearSelection } =
    useCascaderState<OptionType>();
  const { getComponent } = useCascaderComponentsContext<OptionType>();
  const CustomClearIndicator = useMemo(
    () => getComponent(CASCADER_SUBCOMPONENT_NAMES.CLEAR_INDICATOR),
    [getComponent],
  );

  return (
    <CustomClearIndicator
      getCommonProps={getCommonProps}
      __css={cascaderStyles.clearIndicator}
      onClick={handleClearSelection}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          handleClearSelection();
        }
      }}
      className="cascader-clear-indicator"
    />
  );
};

export const ClearIndicator = <OptionType extends CascaderOption>({
  getCommonProps: _,
  ...rest
}: ClearIndicatorProps<OptionType>) => {
  return (
    <Box as="button" {...rest} tabIndex={-1}>
      <CloseIcon boxSize="calc(100% * 2 / 3)" />
    </Box>
  );
};
